// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { createAxios } from 'ts/createAxios';
import { MyPageFormDataMapper, MyPageResponse, MyPageType } from 'types/mypage';
import { getApiPath } from 'util/commons';
import { API_ENDPOINTS } from 'util/endPoints';
import { handleError } from 'util/errorHandler';

const mapPathByMyPageType: Record<MyPageType, string> = {
  [MyPageType.CollectionAdminOperator]: 'collect',
  [MyPageType.CollectionUserNormal]: 'collect',
  [MyPageType.AdminPool]: 'pool',
  [MyPageType.CompressionAdminOperator]: 'compression',
  [MyPageType.RecycleAdminOperator]: 'recycle',
  [MyPageType.EmissionAdminOperator]: 'emission',
  [MyPageType.EmissionAdminSite]: 'emission',
};

export const getMypage = async <T extends MyPageType>({
  myPageType,
  callback,
}: {
  myPageType: T;
  callback?: (data: MyPageResponse<T>) => void;
}) => {
  try {
    const api = createAxios();
    const { data } = await api.get<MyPageResponse<T>>(
      getApiPath(API_ENDPOINTS.MYPAGE, {
        operatorType: mapPathByMyPageType[myPageType],
      })
    );

    if (callback) {
      callback(data);
    }

    return data;
  } catch (error) {
    handleError(error);
    return undefined;
  }
};

export const updateMypage = async <T extends keyof MyPageFormDataMapper>({
  myPageType,
  formData,
  callback,
  errorCallback,
}: {
  myPageType: T;
  formData: MyPageFormDataMapper[T];
  callback?: () => void;
  errorCallback?: () => void;
}) => {
  try {
    const api = createAxios();
    const { data } = await api.put(
      getApiPath(API_ENDPOINTS.MYPAGE, {
        operatorType: mapPathByMyPageType[myPageType],
      }),
      formData
    );

    if (callback) {
      callback();
    }

    return data;
  } catch (error) {
    handleError(error);
    if (errorCallback) {
      errorCallback();
    }
    return undefined;
  }
};
